module.exports = __webpack_public_path__ + "img/mm.92e9f832.svg";